import { useMemo } from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useLoginStateAsync } from '#src/app/shared/hooks/session';
import type { StateWithoutError } from '#src/app/shared/utils/async';
import { isLoading } from '#src/app/shared/utils/async';

type GeolocationEnabledState = StateWithoutError<{ enabled: boolean }>;

export function useGeolocationEnabled(): GeolocationEnabledState {
	const {
		data: {
			featureConfigs: { geoFieldsEnabled, geolocGuestDisabled },
		},
	} = usePetitionDetailsPageData();
	const loginState = useLoginStateAsync();

	const loadingState = useMemo(() => ({ status: 'loading' as const }), []);

	return useMemo(() => {
		if (isLoading(loginState)) {
			return loadingState;
		}

		const enabled = geoFieldsEnabled && (loginState.value !== 'GUEST' || !geolocGuestDisabled);

		return { status: 'loaded' as const, enabled };
	}, [geoFieldsEnabled, geolocGuestDisabled, loginState, loadingState]);
}
